'use strict';

import langJson from './Languages.json'
import Constants from "./Constants";


class Language {

    constructor() {
        this.currentLang = 'ja';
        this.itemKbn = Constants.itemKbn;
    }

    setLanguage(lang, itemKbn) {

        let typeName = '';
        switch (itemKbn - 0) {
        case this.itemKbn.bag.code:
            typeName = 'bag';
            break;
        case this.itemKbn.watch.code:
            typeName = 'watch';
            break;
        case this.itemKbn.jewely.code:
        case this.itemKbn.accessory.code:
            typeName = 'jewely';
            break;
        }

        $('.statusContainer').removeClass('en').addClass(lang);

        let translate = langJson[lang];
        let $doms = $('.lang');


        switch (lang) {
        case 'en':

            // 種別ごとのoverride
            let override = langJson.override[lang][typeName];

            if (override != undefined) {
                translate = Object.assign(translate, override);
            }

            for (let idx = 0; idx < $doms.length; idx++) {
                let $obj = $($doms[idx]);
                $obj.data('text', $obj.text());
                $obj.text(translate[$obj.text()]);
            }
            break;

        default:

            // jaの場合、日本語に戻す
            if (this.currentLang !== 'ja') {

                let $doms = $('.lang');

                for (let idx = 0; idx < $doms.length; idx++) {
                    let $obj = $($doms[idx]);
                    if ($obj.data('text') != undefined) {
                        $obj.text($obj.data('text'));
                    }
                }
            }

            break;
        }

        this.currentLang = lang;
    }

}

export default Language;




